import * as React from "react";

import { CreateImmunisationCaseModal } from "../../crud/ohCase/components/CreateImmunisationCaseModal";

import { All } from "./All";
import Create from "./Create";
import { Edit } from "./Edit";
import { Details } from "./Details";
import { ImmunisationRecord } from "./ImmunisationRecord";

import { Fragment } from "redux-little-router";

const Base: React.SFC = () => {
    return (
        <>
            <Fragment forRoute="/immunisationRecord">
                <ImmunisationRecord />
            </Fragment>
            <Fragment forRoute="/" withConditions={l => l.params.immunisationId === undefined}>
                <>
                    <All />
                    <Create />
                    <CreateImmunisationCaseModal />
                </>
            </Fragment>
            <Fragment forRoute="/:immunisationId">
                <>
                    <Details />
                    <Edit />
                </>
            </Fragment>
        </>
    );
};

export default Base;
